import {Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import {UtilsService} from '../../../core/utils/utils.service';

@Component({
  selector: 'app-length',
  templateUrl: './length.component.html',
  styleUrls: ['./length.component.scss'],
  host: {
    '(document:mousedown)': 'onClick($event)'
  }
})
export class LengthComponent implements OnInit {

  @Input() length: number;

  @Output() lengthChanged = new EventEmitter();

  @ViewChild('popover') popover;

  showLengthPopover: boolean;

  intermediateLength: any;

  constructor(private utilsService: UtilsService) { }

  ngOnInit() {
    this.intermediateLength = this.length;
  }


  private onClick(event): void {
    if (this.showLengthPopover
      && (
        !this.popover._popover
        || !this.popover._popover._componentRef
        || !this.popover._popover._componentRef.location
        || !this.popover._popover._componentRef.location.nativeElement
        || !this.popover._popover._componentRef.location.nativeElement.contains(event.target)
      )
    ) {
      this.hide();
    }
  }

  hide() {
    this.showLengthPopover = false;
    this.popover.hide();
  }

  show() {
    this.showLengthPopover = true;
    this.popover.show();
  }

  getFormattedLength() {
   return this.utilsService.getHMfromMinutes(this.length);
  }

  setLength(length) {
    this.lengthChanged.next(+length);
    this.showLengthPopover = false;
  }

}



// WEBPACK FOOTER //
// ./client/app/routes/shared/length/length.component.ts